import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './tailor/Header';
import Footer from './tailor/Footer';
import Home from './tailor/Home';
import Lookbook from './tailor/Lookbook';
import Fittings from './tailor/Fittings';
import Appointment from './tailor/Appointment';

export default function TailorTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#E5DDCB]" data-testid="tailor-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`tailor-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'lookbook' && <Lookbook setPage={setPage} />}
          {page === 'fittings' && <Fittings setPage={setPage} />}
          {page === 'appointment' && <Appointment setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
